
import ShPopconfirm from '@/components/Helpers/ShPopconfirm';
import ShTextWrapper from '@/components/Helpers/ShTextWrapper';

// @vue/component
export default {
  name: 'DomainsListItem',

  components: {
    ShPopconfirm,
    ShTextWrapper,
  },

  props: {
    domain: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      windowWidth: window.innerWidth,
    };
  },

  mounted() {
    window.addEventListener('resize', this.onResize);
  },
  destroyed() {
    window.removeEventListener('resize', this.onResize);
  },

  methods: {
    async handleDeleteDomain(domain) {
      try {
        await this.$store.dispatch('domains/delete', domain.id);
        this.$notify.success({
          title: 'Usunięcie domeny',
          message: `Usunięto domenę: ${domain.domain}`,
          customClass: 'callmeweb-notification',
        });
        await this.$store.dispatch('domains/getList');
      } catch (err) {
        console.log();
      }
    },
    onResize() {
      this.windowWidth = window.innerWidth;
    },
  },
};
